import styled from '@emotion/styled';
import { css } from '@emotion/react';

export const StyledNetworkStatusError = styled('div')(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 16px;
    .alert-icon {
      color: ${theme.palette.gray.dark};
    }
    .alert-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      gap: 8px;
      .alert-title {
        font-size: ${theme.typography.subtitleBold.fontSize};
        font-family: ${theme.typography.subtitleBold.fontFamily};
        font-weight: ${theme.typography.subtitleBold.fontWeightRegular};
        color: ${theme.palette.gray.dark};
      }
      .alert-description {
        font-size: ${theme.typography.captionLight.fontSize};
        font-family: ${theme.typography.captionLight.fontFamily};
        font-weight: ${theme.typography.captionLight.fontWeightRegular};
        color: ${theme.palette.gray.dark};
        text-align: center;
      }
    }
  `
);
